export default __webpack_public_path__ + "static/media/LAP_Marketplace.a21e1ce0.jpg";